import React, { Fragment } from 'react';

const DiscussionPoints = () => {
  return (
    <Fragment>
      <div className="discussion-key-points">
        <div className="flex-only">
          <p className="sub-section green mr-5">Key Discussion Points</p>
          <i className="far fa-comments mx-5 white fa-lg"></i>
        </div>
        <div className="sub-grid-three-alt">
          <div className="discussion-point-container">
            <div className="flex-only">
              <i className="far fa-star mr-5 white mt-5 fa-lg"></i>
              <p className="sub-section green mx-5">Point Name</p>
            </div>
            <div className="discussion-point-description">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Quibusdam modi tempora pariatur vel quam, voluptatibus laudantium
              ut asperiores illum a!
            </div>
          </div>
          <div className="discussion-point-container">
            <div className="flex-only">
              <i className="far fa-star mr-5 white mt-5 fa-lg"></i>
              <p className="sub-section green mx-5">Point Name</p>
            </div>
            <div className="discussion-point-description">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Quibusdam modi tempora pariatur vel quam, voluptatibus laudantium
              ut asperiores illum a!
            </div>
          </div>
          <div className="discussion-point-container">
            <div className="flex-only">
              <i className="far fa-star mr-5 white mt-5 fa-lg"></i>
              <p className="sub-section green mx-5">Point Name</p>
            </div>
            <div className="discussion-point-description">
              Lorem ipsum dolor, sit amet consectetur adipisicing elit.
              Quibusdam modi tempora pariatur vel quam, voluptatibus laudantium
              ut asperiores illum a!
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionPoints;
